import * as api from '../dealerApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    dealerActionCreators,
    DealerActionKeys,
    IPreseasonGoalUpdateResponse,
    UpdatePreseasonGoal
    } from '..';

function* updatePreseasonGoalSaga(action: UpdatePreseasonGoal) {
  const response: IPreseasonGoalUpdateResponse = yield call(api.updatePreseasonGoal, action.payload);

  yield put(dealerActionCreators.setPreseasonGoal(response));
}

export function* watchUpdatePreseasonGoal() {
  yield takeEvery(DealerActionKeys.UPDATE_PRESEASON_TARGET, updatePreseasonGoalSaga);
}
